import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=53c76788&lang=pug&"
import script from "./cart-item.vue?vue&type=script&lang=js&"
export * from "./cart-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports